<div class="tags-wrapper">
    <div id="tagsList" class="tags-cloud">
        <div class="input-group" style="width: 100%">
            <input type="text" id="searchInput" autocomplete="off" (keydown)="checkKeyDown($event)" class="form-control" [(ngModel)]="searchText" (ngModelChange)="search()" [disabled]="disabled" />
            <span class="input-group-btn">
                <button type="button" class="btn btn-outline-dark mr-0" (click)="addToSelectedTags(selectedIndex, 'TO')" [disabled]="disabled">Add To</button>
                <button type="button" class="btn btn-outline-dark mr-0" (click)="addToSelectedTags(selectedIndex, 'CC')" [disabled]="disabled">Add CC</button>
                <button type="button" class="btn btn-outline-dark mr-0" (click)="addToSelectedTags(selectedIndex, 'BCC')" [disabled]="disabled">Add BCC</button>
            </span>
        </div>
    </div>
    <ul id="suggestions" class="suggestions-list">
        <li *ngFor="let suggestion of suggestions;let $index = index" class="blockSpan" (click)="addToInput($index)" (mouseover)="selectedIndex=$index" [ngClass]="{active : selectedIndex===$index}">{{suggestion.DisplayName}} ({{suggestion.EmailAddress}})</li>
    </ul>
</div>